<script setup lang="ts">
import {useAuthStore} from "@/stores/auth";
import TsButton from "@/components/app/TsButton.vue";

// Uses
const auth = useAuthStore()

// Computed
const tooltip = computed(() => {
    return `Wechsle zurück in deinen Admin Account ${auth.imposterName}`
})

// :tooltip="tooltip"

</script>

<template>
    <div v-if="auth.isImposter">
        <v-chip
            prepend-icon="mdi-account"
            append-icon-color="red"
            color="grey-darken-3"
            variant="flat"
            label
        >{{ auth.imposterName }}</v-chip>
        <ts-button
            type="danger"
            fluid
            size="33"
            corner="2"
            class="ml-1"
            loaded
            :load-function="auth.jumpBackAccount"

        ><v-icon icon="mdi-logout" class="mx-4"></v-icon></ts-button>
    </div>
</template>

<style scoped lang="scss">

</style>